/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Award inventory with no cash counterpart, so no cents-per-point is computable.
 * @export
 * @interface FlightPointsOnlyOffer
 */
export interface FlightPointsOnlyOffer {
    /**
     * 
     * @type {string}
     * @memberof FlightPointsOnlyOffer
     */
    flightNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof FlightPointsOnlyOffer
     */
    pointsCost?: number;
    /**
     * 
     * @type {number}
     * @memberof FlightPointsOnlyOffer
     */
    pointsCashCost?: number;
    /**
     * 
     * @type {string}
     * @memberof FlightPointsOnlyOffer
     */
    pointsCurrencyCode?: string;
    /**
     * 
     * @type {Date}
     * @memberof FlightPointsOnlyOffer
     */
    departsAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FlightPointsOnlyOffer
     */
    arrivesAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof FlightPointsOnlyOffer
     */
    airline?: string;
    /**
     * 
     * @type {string}
     * @memberof FlightPointsOnlyOffer
     */
    cabinClass?: string;
}

/**
 * Check if a given object implements the FlightPointsOnlyOffer interface.
 */
export function instanceOfFlightPointsOnlyOffer(value: object): value is FlightPointsOnlyOffer {
    return true;
}

export function FlightPointsOnlyOfferFromJSON(json: any): FlightPointsOnlyOffer {
    return FlightPointsOnlyOfferFromJSONTyped(json, false);
}

export function FlightPointsOnlyOfferFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightPointsOnlyOffer {
    if (json == null) {
        return json;
    }
    return {
        
        'flightNumber': json['flight_number'] == null ? undefined : json['flight_number'],
        'pointsCost': json['points_cost'] == null ? undefined : json['points_cost'],
        'pointsCashCost': json['points_cash_cost'] == null ? undefined : json['points_cash_cost'],
        'pointsCurrencyCode': json['points_currency_code'] == null ? undefined : json['points_currency_code'],
        'departsAt': json['departs_at'] == null ? undefined : (new Date(json['departs_at'])),
        'arrivesAt': json['arrives_at'] == null ? undefined : (new Date(json['arrives_at'])),
        'airline': json['airline'] == null ? undefined : json['airline'],
        'cabinClass': json['cabin_class'] == null ? undefined : json['cabin_class'],
    };
}

export function FlightPointsOnlyOfferToJSON(json: any): FlightPointsOnlyOffer {
    return FlightPointsOnlyOfferToJSONTyped(json, false);
}

export function FlightPointsOnlyOfferToJSONTyped(value?: FlightPointsOnlyOffer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'flight_number': value['flightNumber'],
        'points_cost': value['pointsCost'],
        'points_cash_cost': value['pointsCashCost'],
        'points_currency_code': value['pointsCurrencyCode'],
        'departs_at': value['departsAt'] == null ? value['departsAt'] : value['departsAt'].toISOString(),
        'arrives_at': value['arrivesAt'] == null ? value['arrivesAt'] : value['arrivesAt'].toISOString(),
        'airline': value['airline'],
        'cabin_class': value['cabinClass'],
    };
}

